import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  TrainerEarningsArgs,
  TrainerEarningsItemsArgs,
} from '../api/types/trainerEarnings.types';

import {
  fetchTrainerEarnings,
  fetchTrainerEarningsItems,
} from '../api/trainerEarnings.api';

/**
 * MV2-577 Part 2 (3.4) — the key is `[args]`, and the args carry the ACTING
 * tenant as well as the organization, range, bucket size and currency (the
 * items: trainer and page too). The tenant is in the key and nowhere else: a
 * super-admin's tenant switch must never be answered from another tenant's
 * cache entry, while the BE refuses it as a query parameter.
 */
export const trainerEarningsQueryKeys = createQueryKeys('trainerEarnings', {
  report: (args: TrainerEarningsArgs) => ({
    queryFn: () => fetchTrainerEarnings(args),
    queryKey: [args],
  }),
  items: (args: TrainerEarningsItemsArgs) => ({
    queryFn: () => fetchTrainerEarningsItems(args),
    queryKey: [args],
  }),
});
